module.exports = __webpack_public_path__ + "static/img-18-490140ab99974a11a6d5642b1ba530f1.jpeg";